import Icon from './Icon';

// The "this note is linked" mark (owner, 16/10/2026): a link glyph beside a
// תעודת משלוח / תעודת החזרה that a חשבונית מרכזת covers. On the supplier page
// and the /suppliers/paid drill-down it is the admin's only (the caller gates
// on isAdmin, and the server fills linked_invoice_doc_num there for admins
// only);
// on /documents every role sees it. The server sends linked_invoice_doc_num
// ('' = linked but numberless, NULL = not linked or not this role's to see).
// Unlinked notes carry no mark.
//
// Neutral ink, not amber or gold: nothing is wrong (amber is the UNlinked
// warning on /suppliers) and it is not an owner-only mark (gold). The row's
// status badge stays its only coloured element.
//
// The tooltip naming the מרכזת is desktop-only (`showTip`): it is a hover
// affordance, and on a phone the row is already a tap target of its own. The
// aria-label carries the same words either way.
export function linkedNoteLabel(invoiceDocNum) {
  const num = invoiceDocNum == null ? '' : String(invoiceDocNum).trim();
  return num ? `מקושרת לחשבונית מרכזת מס׳ ${num}` : 'מקושרת לחשבונית מרכזת (ללא מספר)';
}

export default function LinkedNoteMark({ invoiceDocNum, showTip = false }) {
  const label = linkedNoteLabel(invoiceDocNum);
  return (
    // Not a tab stop: /documents can list thousands of linked notes, and one
    // stop each would bury the row actions (perf review, 16/10/2026). The
    // aria-label already gives a screen reader the invoice number.
    <span className="linked-note-mark" role="img" aria-label={label}>
      <Icon name="link" size={13} />
      {showTip && <span className="dn-tip" aria-hidden="true">{label}</span>}
    </span>
  );
}
